import React from "react";
import style from "./style.module.scss";

type PropsType = {
  children: React.ReactNode;
  className?: string;
};

export const CardDetails = ({ children, className }: PropsType) => {
  return <div className={`${style.card_details} ${className}`}>{children}</div>;
};
